import styled from '@emotion/styled';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  position:relative;
`;
